import { render, staticRenderFns } from "./AcademicLoadView.vue?vue&type=template&id=98c1a76c"
import script from "./AcademicLoadView.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademicLoadView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports